module.exports = __webpack_public_path__ + "img/platnosci_zblizeniowe.367bfe5c.png";